var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4813 7.87939C43.0437 8.44197 43.3597 9.2049 43.3597 10.0004C43.3597 10.7959 43.0437 11.5588 42.4813 12.1214L22.6139 40.1785C22.3167 40.4757 21.9639 40.7115 21.5756 40.8724C21.1873 41.0332 20.7712 41.116 20.3509 41.116C19.9306 41.116 19.5144 41.0332 19.1261 40.8724C18.7378 40.7115 18.385 40.4757 18.0879 40.1785L6.91586 29.0085C6.62933 28.7318 6.40079 28.4007 6.24356 28.0347C6.08633 27.6687 6.00357 27.275 6.00011 26.8767C5.99665 26.4784 6.07256 26.0833 6.2234 25.7146C6.37424 25.3459 6.597 25.011 6.87868 24.7293C7.16036 24.4476 7.49531 24.2249 7.864 24.074C8.23269 23.9232 8.62773 23.8473 9.02607 23.8507C9.42441 23.8542 9.81807 23.937 10.1841 24.0942C10.5501 24.2514 10.8811 24.48 11.1579 24.7665L20.3499 33.9585L38.2373 7.87939C38.5159 7.60061 38.8467 7.37946 39.2108 7.22858C39.5749 7.07769 39.9652 7.00003 40.3593 7.00003C40.7534 7.00003 41.1437 7.07769 41.5078 7.22858C41.8719 7.37946 42.2027 7.60061 42.4813 7.87939Z",
    fill: "#76A140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.41703646599f424c76770f6004bc7e7c.svg";
export { ForwardRef as ReactComponent };